import { registerBlotterRegistrationListeners } from '@/store/blotter/workflows/registration/listeners.ts';
import { registerSummonOrderListener } from '@/store/blotter/workflows/summonOrder/listeners.ts';
import type { StartAppListening } from '@/store/listenerMiddleware.ts';

export function registerBlotterListeners(startAppListening: StartAppListening): void {
  registerBlotterRegistrationListeners(startAppListening);
  registerSummonOrderListener(startAppListening);
}
